<template>
  <div class="container">
    <div class="container">
      <div class="header">
        <div class="title">留言回复</div>
      </div>
      <div class="content">
        <el-card class="box-card">
          <div class="item-title">
            <span class="typeName"><span style="font-weight:bold">{{ item.username }}</span>留言：</span>
            <span class="time">{{ item.createTime }}</span>
          </div>
          <div class="item-content">
            <el-tag size="mini">{{ item.type }}</el-tag>
            <div class="title">{{ item.title }}</div>
            <div class="message-content">{{ item.qcontent }}</div>
          </div>
        </el-card>
        <el-card class="box-card" id="box-cards">
          <div class="item-title">
            <span class="typeName">回复：</span>
          </div>
          <div class="item-content">
            <el-input type="textarea" :rows="5" resize="none" :value="item.reply.rcontent" readonly>
            </el-input>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
// import Reply from '@/components/reply'
export default {
  name: 'messageReply',
  data () {
    return {
      item: {
        reply: {
          rcontent: '你好'
        }
      },
      isReply: false,
      itemId: ''
    }
  },
  // components: {
  //   Reply
  // },
  mounted () {
    console.log(this.$route.params.id)
    this.itemId = this.$route.params.id
    this.getItemInfo()
  },
  methods: {
    getItemInfo () {
      this.$http.getItemInfo({id: this.itemId}).then((result) => {
        // console.log(result.data.reply.rcontent, '29')
        if (result.success) {
          this.item = result.data
          if (result.data.reply) {
            this.isReply = true
          }
        }
      }).catch((err) => {
        console.error(err)
      })
    }
  }
}
</script>
<style lang="scss">
#box-cards {
  .item-content {
    .el-textarea {
      .el-textarea__inner {
        padding: 0;
        padding-top: 3px;
        font-size: 14px !important;
        color: black !important;
      }
    }
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$color: #6e348b;

.header {
  display: flex;
  justify-content: center;
  color: $color;
  padding: 10px 0;
  font-size: 1em;
  font-weight: 600;

  .icon {
    width: 30px;
  }
}

.el-card {
  margin: 10px 0;

  .item-title {
    display: flex;
    color: #606266;
    justify-content: space-between;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .item-content {
    &>div {
      font-size: 14px;
      margin-bottom: 10px;
    }
  }
}

.el-button {
  width: 100%;
  margin-top: 30px;
}

.typeName {
  font-size: 16px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/reply.vue